module.exports = __webpack_public_path__ + "static/media/help-circle-outline.a20a36b2.png";